module.exports = __webpack_public_path__ + "img/866ca1c9816098c8a06f28d861c7f078.png";